var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 214.918,
    height: 56.986,
    viewBox: "0 0 214.918 56.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6205",
    "data-name": "Group 6205",
    transform: "translate(-574.882 -212.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "star_3",
    d: "M56.3,22.027a3.031,3.031,0,0,0-2.583-2.173L37.423,18.295,30.981,2.41a2.942,2.942,0,0,0-5.517,0L19.022,18.295,2.728,19.853a3.037,3.037,0,0,0-2.58,2.173,3.268,3.268,0,0,0,.877,3.357L13.339,36.762,9.708,53.613a3.246,3.246,0,0,0,1.167,3.263,2.856,2.856,0,0,0,3.295.152l14.053-8.848L42.27,57.027a2.863,2.863,0,0,0,3.3-.152,3.249,3.249,0,0,0,1.167-3.263L43.1,36.762,55.418,25.386A3.272,3.272,0,0,0,56.3,22.027Zm0,0",
    transform: "translate(733.356 212.129)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("path", {
    id: "star_2",
    d: "M56.3,22.027a3.031,3.031,0,0,0-2.583-2.173L37.423,18.295,30.981,2.41a2.942,2.942,0,0,0-5.517,0L19.022,18.295,2.728,19.853a3.037,3.037,0,0,0-2.58,2.173,3.268,3.268,0,0,0,.877,3.357L13.339,36.762,9.708,53.613a3.246,3.246,0,0,0,1.167,3.263,2.856,2.856,0,0,0,3.295.152l14.053-8.848L42.27,57.027a2.863,2.863,0,0,0,3.3-.152,3.249,3.249,0,0,0,1.167-3.263L43.1,36.762,55.418,25.386A3.272,3.272,0,0,0,56.3,22.027Zm0,0",
    transform: "translate(654.119 212.129)",
    fill: "#f2f2f2",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("path", {
    id: "star_1",
    d: "M56.3,22.027a3.031,3.031,0,0,0-2.583-2.173L37.423,18.295,30.981,2.41a2.942,2.942,0,0,0-5.517,0L19.022,18.295,2.728,19.853a3.037,3.037,0,0,0-2.58,2.173,3.268,3.268,0,0,0,.877,3.357L13.339,36.762,9.708,53.613a3.246,3.246,0,0,0,1.167,3.263,2.856,2.856,0,0,0,3.295.152l14.053-8.848L42.27,57.027a2.863,2.863,0,0,0,3.3-.152,3.249,3.249,0,0,0,1.167-3.263L43.1,36.762,55.418,25.386A3.272,3.272,0,0,0,56.3,22.027Zm0,0",
    transform: "translate(574.882 212.129)",
    fill: "#f2f2f2",
    opacity: 0.998
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.0abe91f2.svg";
export { ForwardRef as ReactComponent };